import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useTipoCriterio = () => {
  const [tipoCriterio, setTipoCriterio] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchTipoCriterio = async () => {
      try {
        const response = await httpClient.get(
          `/api/medsuscriterio/tipocriterio`,
        );

        const options = response.data.map(
          (tipoCriterio: { value: number; label: string }) => ({
            value: tipoCriterio.value.toString(),
            label: tipoCriterio.label,
          }),
        );
        setTipoCriterio(options);
      } catch (error) {
        console.error('Erro ao buscar Tipo Criterio', error);
      }
    };

    fetchTipoCriterio();
  }, []);

  return tipoCriterio;
};
